<template>
  <div>
    <back-route-hdr :back-mode="'static'"></back-route-hdr>
    <!-- 报修相关 -->
    <div class="mar-top">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div v-if="refreshTime && !repairEdges.length">
          <empty-notice :image="'search'" :desc="'暂无报修内容'"></empty-notice>
        </div>
        <div v-else class="custom-steps">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell-group v-for="(info, index) in repairCells" :key="index" :title="info.month">
              <van-swipe-cell v-for="(rpr,idx) in info.list" :key="idx">
                <van-cell>
                  <template #title>
                    <span>{{rpr.title}}</span>
                    <van-tag class="pull-right" :type="rpr.statusStyle">{{rpr.statusCN}}</van-tag>
                  </template>
                  <template #label>
                    <span v-if="rpr.cancelReason">取消原因：{{rpr.cancelReason}}</span>
                    <p class="mar-top-5 mar-btm-0">{{rpr.roomNum}}</p>
                    <p class="mar-top-5 mar-btm-0">
                      <span>{{rpr.label}}</span>
                      <van-tag class="mar-lft-5" :type="rpr.severityStyle">{{rpr.severityCN}}</van-tag>
                    </p>
                  </template>
                </van-cell>
                <template #right>
                  <!-- 根据报修状态渲染按钮 -->
                  <van-button v-for="(e,idx) in getBtnList(rpr)" :key="idx"
                              :text="e.text" :type="e.style"
                              class="hgt-100-percent" square
                              @click="handleStatus(rpr, e)">
                  </van-button>
                  <van-button v-show="!getBtnList(rpr).length" square
                              type="danger" class="hgt-100-percent" disabled>
                    <i class="fa fa-ban text-center" style="width: 28px"></i>
                  </van-button>
                </template>
              </van-swipe-cell>
            </van-cell-group>
          </van-list>
        </div>
      </van-pull-refresh>

      <cancel-sheet :show="showCancelPopup" :params="cancelParams" @reload="onRefresh()"
                    @handle-cancel="showCancelPopup = $event"></cancel-sheet>

    </div>
  </div>

</template>

<script>
  import {refreshDebounce} from "../../../../tools/utils";
  import {momentFormat, serviceConfig} from "../../../../config/common";
  import {repair} from "../../../../server"
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import CancelSheet from "../../components/CancelSheet"

  export default {
    components: {
      CancelSheet
    },
    data() {
      return {
        userId: getStorage(StorageKey.userId),
        refreshing: false,
        refreshTime: "",
        repairEdges: [],
        finished: false,
        loading: false,
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          pages: 1,
        },
        showCancelPopup: false,
        cancelRprId: ""
      }
    },
    computed: {
      statusMap: function () {
        const obj = {};
        const sysConfig = this.$store.state.sysConfig || {};
        (sysConfig.serviceStatus || []).forEach(ele => obj[ele.value] = ele.label);
        return obj
      },
      // 报修信息
      repairCells() {
        const obj = {};
        this.repairEdges.forEach(edge => {
          const repairDoc = edge.repair;
          const dmd = (repairDoc.devices || []).map(e => `${e.name}`);
          repairDoc.specificContent && dmd.push(repairDoc.specificContent);
          const time = moment(repairDoc.createdDate).format("MM月DD日 HH:mm");
          const severity = repairDoc.severity || "prompt";
          const ele = {
            ...repairDoc,
            cursor: edge.cursor,
            statusCN: this.statusMap[repairDoc.status] || repairDoc.status,
            title: dmd.join('；'),
            statusStyle: serviceConfig.statusStyle[repairDoc.status] || serviceConfig.statusStyle.CANCELED,
            label: time,
            roomNum: repairDoc.meetingRoom && repairDoc.meetingRoom.roomNum,
            severityCN: serviceConfig.severityMap[severity],
            severityStyle: serviceConfig.severityStyleMap[severity]
          };
          const month = moment(ele.createdDate).format(momentFormat.dateFormatMonthCN);
          if (obj[month]) {
            obj[month].push(ele)
          } else {
            obj[month] = [ele]
          }
        });
        return Object.keys(obj).map(k => ({
          month: k,
          list: obj[k]
        }))
      },
      // 取消提交参数
      cancelParams() {
        return {
          repairId: this.cancelRprId,
          status: serviceConfig.status.CANCELED,
        }
      }
    },
    methods: {
      onRefresh() {
        // console.log(this.refreshing);
        // 刷新防抖动
        if (this.refreshTime && refreshDebounce(this.refreshTime)) {
          this.refreshing = false;
          vtToast('刷新成功');
          return
        }
        this.initRepairList();
      },
      onLoad() {
        this.getRepairList(this.pageInfo.pageNum++)
      },
      initRepairList() {
        this.pageInfo.pageNum = 1;
        this.refreshTime = "";
        this.repairEdges = [];
        this.finished = false;
        this.onLoad()
      },
      // 查询报修信息
      getRepairList(pageNum) {
        const filter = {
          pageNum,
          pageSize: this.pageInfo.pageSize,
          createdBy: this.userId,
        };
        !this.refreshing && !this.loading && UILoader.load();
        repair.queryList(this, {queryFilter: filter}).then(({searchRepair: data = {}}) => {
          UILoader.unload();
          this.loading = false;
          const {repairEdges, pageInfo} = data;
          this.repairEdges = this.repairEdges.concat(repairEdges || []);
          if (this.refreshing) {
            this.refreshing = false;
            vtToast('刷新成功');
          }
          this.refreshTime = new Date();
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
        }).catch(err => {
          UILoader.unload();
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
          vtToast(err.message)
        })
      },
      // 根据状态处理按钮
      getBtnList(sv) {
        if (serviceConfig.doneStatus.includes(sv.status)) return [];
        if (sv.initiator && sv.initiator.userId === this.userId) {
          return [{
            text: "取消",
            style: "danger",
            status: serviceConfig.status.CANCELED,
          }]
        }
        return []
      },
      // 报修状态改变
      handleStatus(rpr, ele) {
        if (!rpr.cursor) return;
        if (ele.status === serviceConfig.status.CANCELED) {
          this.cancelRprId = rpr.cursor;
          this.showCancelPopup = true;
        }
      }
    }
  }
</script>

<style scoped>
</style>
